
import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PaymentSuccessViewProps {
  onReset: () => void;
}

const PaymentSuccessView: React.FC<PaymentSuccessViewProps> = ({ onReset }) => {
  return (
    <div className="text-center py-8 px-6">
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <ShieldCheck className="h-8 w-8 text-green-500" />
      </div>
      <h3 className="text-xl font-medium text-gray-900 mb-2">Transfer Complete</h3>
      <p className="text-gray-500 mb-6">Your payment has been processed successfully</p>
      <Button onClick={onReset}>
        Make Another Payment
      </Button>
    </div>
  );
};

export default PaymentSuccessView;
